import { axiosInventoryInstance } from '@/config/apiConfig';
import { AxiosResponse } from 'axios';
import { API_URL_CONFIG } from '@/config/urlConfig/apiUrlConfig';
import { ILocation } from '@/store/sagas/locationSaga';
import {
  ICreateLocation,
  IDeleteLocation,
  IFetchLocation,
  IUpdateLocation,
} from './location.type';

// Define the Location interface representing the structure of the user object returned by the API

export const fetchLocations = ({
  page,
  limit,
  operatorId,
}: IFetchLocation): Promise<AxiosResponse<ILocation[], any>> => {
  return axiosInventoryInstance({
    url: API_URL_CONFIG.LOCATION.GET_ALL_LOCATION,
    params: {
      page,
      limit,
      operatorId,
    },
  });
};
export const fetchLocation = (
  id: number,
): Promise<AxiosResponse<ILocation>> => {
  return axiosInventoryInstance.get(
    `${API_URL_CONFIG.LOCATION.GET_ALL_LOCATION}/${id}`,
  );
};

export const createLocation = (
  payload: ICreateLocation,
): Promise<AxiosResponse<ILocation>> => {
  return axiosInventoryInstance.post(
    `${API_URL_CONFIG.LOCATION.CREATE_LOCATION}`,
    payload,
  );
};

export const updateLocation = (
  id: string,
  payload: IUpdateLocation,
): Promise<AxiosResponse<ILocation>> => {
  const body = {
    sourceLocationId: payload?.sourceLocationId,
    locationName: payload?.locationName,
  };
  return axiosInventoryInstance.patch(
    `${API_URL_CONFIG.LOCATION.GET_LOCATION}/${id}`,
    { ...body },
  );
};

export const deleteLocation = (
  id: IDeleteLocation,
): Promise<AxiosResponse<IDeleteLocation, any>> => {
  return axiosInventoryInstance.delete(
    `${API_URL_CONFIG.LOCATION.GET_LOCATION}/${id}`,
  );
};

export const fetchAllLocationsList = ({
  page = 1,
  limit = 10,
  operatorId = '',
  providerId = '',
  marketId = '',
  orderBy,
  order,
  name,
}: IFetchLocation): Promise<AxiosResponse<IFetchLocation, any>> => {
  let params: any = {
    page,
    limit,
    ...(orderBy ? { orderBy } : {}),
    ...(order ? { order } : {}),
    ...(name ? { name } : {}),
  };

  // //BackEnd Will Accept any ONE of [providerId , operatorId , marketId]
  if (providerId !== '') {
    params.providerId = providerId;
  } else if (operatorId !== '') {
    params.operatorId = operatorId;
  } else if (marketId !== '') {
    params.marketId = marketId;
  }

  if (!params.operatorId && !params.marketId && !params.providerId) {
    params = {
      ...params,
      operatorId: 1, // Set operatorId to 1
    };
  }
  return axiosInventoryInstance({
    url: API_URL_CONFIG.LOCATION.GET_LOCATIONS_LIST,
    params,
  });
};
